import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-style-guide';
import useScrollIntoView from '../utilities/useScrollIntoView';

function GetPremiumButton({ translate, ...otherProps }) {
  const clickHandler = useScrollIntoView('premium-memberships');

  return (
    <Button
      className='get-premium-button'
      variant={Button.variants.primary}
      width={Button.widths.min}
      onClick={clickHandler}
      {...otherProps}>
      {translate('Action.GetPremium')}
    </Button>
  );
}

GetPremiumButton.defaultProps = {
  size: Button.sizes.large
};

GetPremiumButton.propTypes = {
  translate: PropTypes.func.isRequired,
  size: PropTypes.string
};

export default GetPremiumButton;
